import React, { useState } from "react";
import { Container, Button, Row, Form, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import configuration from "react-global-configuration";
import { useTranslation, setLanguage } from "react-multi-lang";
import Select from "react-select";
import { apiConstants } from "../../Constant/constants";

const FooterIndex = (props) => {
  const t = useTranslation("footer");

  const handleChange = (selectedOption) => {
    setLanguage(selectedOption.value)
    localStorage.setItem('lang', selectedOption.value);
    window.location.reload();
  };

  const options = [{ value: "en", label: t("english") }, { value: "es", label: t("spanish") }];

  const customStyles = {
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      left: "0px",
      borderRadius: "8px",
      overflow: "hidden",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
      minWidth: 250,
      fontSize: "0.85em",
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.3)",
        borderRadius: "3px",
        backgroundColor: "#fff",
      },
      "&::-webkit-scrollbar": {
        width: "4px",
        backgroundColor: "#fff",
      },
      "&::-webkit-scrollbar-thumb": {
        borderRadius: "3px",
        boxShadow: "inset 0 0 6px rgba(0, 0, 0, .3)",
        backgroundColor: "#555",
      },
    }),
    container: (provided) => ({ ...provided, width: "auto" }),
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent!important",
      border: "1px solid #e47c3f!important",
      borderRadius: "8px!important",
      boxShadow: "none!important",
      height: "35px",
      minWidth: "180px",
      cursor: "pointer",
      fontSize: "0.9em",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#e47c3f",
      fontSize: "1.1em",
      fontWeight: "600",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#e47c3f",
      display: "flex",
      alignItems: "center",
      gap: "0.5em",
      fontSize: "0.9em",
      fontWeight: "800",
    }),
    indicatorContainer: (provided) => ({
      ...provided,
      color: "#e47c3f!important",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      svg: {
        fill: "#e47c3f",
      },
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? "#f7f7f7" : "#fff",
        color: "#000",
        "&:hover": {
          backgroundColor: "#f7f7f7",
          color: "#000",
        },
      };
    },
  };

  return (
    <>
      <div className="new-footer-sec sm-padding">
        <Container>
          <div className="call-to-action-box">
            <div className="call-to-action-left-sec">
              <h3>{t("join_us")}!</h3>
              <p>{t("heraldEX_is_more_than_just_an_exchange")}</p>
              <div className="call-to-action-btn-sec">
                <a className="new-default-primary-btn" href="#contact">
                  {t("heading")}
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24"><path stroke="#171717" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M14.43 5.93L20.5 12l-6.07 6.07M11.01 12h9.32M3.5 12h3.47"></path></svg>
                </a>
              </div>
            </div>
            <div className="call-to-action-right-img-sec">
              <Image
                className="call-to-action-right-img"
                src={
                  window.location.origin + "/img/landing/cta/cta-right-img.png"
                }
                type="image/png"
              />
            </div>
          </div>
          <div className="footer-link-sec">
            {/* <p>
              {configuration.get("configData.footer_description")}
            </p> */}
            <div className="footer-copyright-sec">
                <p>{apiConstants.copyright_content}</p>
              </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default FooterIndex;
